import { default_header, default_header_example } from '../defaultData';
import { apiParamDesc, apiActionTable } from '../docHelpers';

const getV12APIs = (userInfo) => {
  return [
    {
      title: '작업 등록',
      url: '/doc/작업 등록',
      data: [
        {
          version: 'v1.2',
          url: '/work/addWork/v1.2',
          method: 'POST',
          desc: (
            <ul className='style'>
              <li>
                <p>호출한 액션의 작업을 등록합니다.</p>
              </li>
              <li>
                <p>작업은 쇼핑몰 별로 동시에 작업 가능합니다.</p>
              </li>
              <li>
                <p>
                  호출가능한 액션은 아래와 같습니다. <br />
                  <br />
                </p>
                {apiActionTable('주문', [
                  {
                    action: 'ScrapOrderConfirmList',
                    desc: '결제완료 주문수집',
                    code: '작업명: 발주 확인전 주문수집',
                    notes: [
                      '발주확인을 지원하지 않는 쇼핑몰은 ScrapOrder 작업으로 자동 등록됩니다.',
                      '스마트스토어 발주 확인 된 주문 수집 시 결제 완료 주문도 같이 수집되고 있으므로 ScrapOrder 액션으로 호출해 주시기 바랍니다.'
                    ]
                  },
                  {
                    action: 'ScrapOrder',
                    desc: '발주확인된 주문 수집',
                    code: '작업명: 주문수집',
                    notes: ['스마트스토어의 경우 해당 액션 호출 시, 결제 완료 주문이 같이 수집됩니다.']
                  },
                  {
                    action: 'ScrapOrderAndConfirmDoit',
                    desc: '결제완료 주문건 모두 발주확인 처리 후 주문수집',
                    code: '작업명: 발주확인후 주문수집',
                    notes: ['발주확인을 지원하지 않는 쇼핑몰은 ScrapOrder 작업으로 자동 등록됩니다.']
                  },
                  {
                    action: 'SyncOrderState',
                    desc: '주문동기화',
                    code: '작업명: 주문동기화'
                  }
                ])}
                <br />
                {userInfo?.aff_no !== 1051 && (
                  <>
                    {apiActionTable('문의', [
                      { action: 'ScrapCS', desc: '문의수집' },
                      { action: 'ScrapEmergencyCS', desc: '긴급 문의 수집' },
                      { action: 'ScrapReview', desc: '상품평 수집' }
                    ])}
                    <br />
                    {apiActionTable('정산', [
                      { action: 'ScrapPayBack', desc: '정산수집' }
                    ])}
                    <br />
                  </>
                )}
                {apiActionTable('상품', [
                  { action: 'ScrapProd', desc: '상품수집' }
                ])}
                <br />
              </li>
              <li>
                <p>쇼핑몰 코드는 쇼핑몰코드 조회 api 를 통하여 확인바랍니다.</p>
              </li>
              <li>
                <p>
                  등록된 작업은 PLAYAUTO 2.0 솔루션에 접속하여 확인가능합니다.
                </p>
              </li>
              <li>
                <p>
                  작업결과는 리턴되는 작업번호(work_no)로 작업결과조회를
                  호출하여 확인가능합니다.
                </p>
              </li>
              <li>
                <p>
                  <code>api_callback_url</code> 등록시 작업결과를 POST 방식으로 입력하신 주소로 전송합니다.<br />
                  - 전송되는 데이터 포멧은 아래의 예시를 참고해주세요
                </p>
                <pre>
                  [{'{'}
                  <br />  work_no: 172279187,
                  <br />  job_name: '주문수집',
                  <br />  status: '완료',
                  <br />  message: ['[성공] : 변경사항이 없습니다'],
                  <br />{'}'}]
                </pre>
              </li>
            </ul>
          ),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'act',
              required: 'O',
              type: 'String',
              desc: '작업액션',
            },
            {
              title: 'params',
              required: 'O',
              type: 'Object',
              desc: '',
            },
            {
              title: 'site_code',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 코드',
              indent: 1,
            },
            {
              title: 'site_id',
              required: 'O',
              type: 'String[]',
              desc: '쇼핑몰 아이디',
              indent: 1,
            },
            {
              title: 'std_ol_yn',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '단일상품여부', sub: '온라인상품 작업시 사용됩니다.',
                defaultValue: 'N',
                allowedValues: ['Y', 'N'] }),
              indent: 1,
            },
            {
              title: 'code_scrap_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '상품 수집 시 특정 상품 수집 여부', sub: '상품수집 작업 시 사용하는 값입니다.',
                allowedValues: [
                  ['true', '특정 상품 가져오기<br />prod_codes(가져올 상품의 쇼핑몰 상품코드)가 필수로 들어가야 합니다.'],
                  ['false', '등록일 기준 모두 가져오기 <br/>prod_scrap_date(수집기간)이 없는경우 1년전 상품까지 수집합니다.']
                ],
                notes: ['값을 넣지않는경우 등록일 기준 전체 수집으로 작업합니다.'] }),
              indent: 1,
            },
            {
              title: 'prod_codes',
              required: '',
              type: 'Array',
              desc: '특정 상품 가져오기 시 가져올 상품의 쇼핑몰 상품코드',
              indent: 1,
            },
            {
              title: 'prod_scrap_date',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '수집기간', sub: '상품 등록일 기준 입력한 값 년전인 상품까지 수집합니다.',
                defaultValue: '1',
                allowedValues: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'] }),
              indent: 1,
            },
            {
              title: 'show_shop_info_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '등록 작업 쇼핑몰정보 노출여부', sub: '콜백URL 결과 데이터 응답 시 사용됩니다.',
                defaultValue: 'false',
                allowedValues: ['true', 'false'] }),
              indent: 1,
            },
            {
              title: 'api_callback_url',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '작업완료시 작업결과를 수신받을 URL', sub: '해당정보 입력시 작업결과를 입력하신 주소로 POST 방식으로 전송합니다.' }),
            },
            ...([1051].includes(userInfo.aff_no) ? [{
              title: 'target',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '스마트스토어 타겟 키', allowedValues: [
                  ['normal', '일반 주문만'],
                  ['guarantee', '도착 주문만'],
                  ['all', '전체']
                ],
                notes: ['값을 넣지않는경우 전체검색됩니다.'] }),
              indent: 1,
            }] : []),
          ],
          body_example: {
            act: 'ScrapOrder',
            params: {
              site_code: 'A001',
              site_id: ['test_shop', 'test_shop2'],
            },
            api_callback_url: 'https://test.io/callback',
          },
          response: [
            {
              title: 'work_no',
              required: 'O',
              type: 'Number',
              desc: '등록된 작업번호',
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '결과 메세지',
            },
          ],
          response_example: {
              "results": [
                  {
                      "shop_cd": "A001",
                      "shop_id": "test_shop",
                      "status": "성공",
                      "work_no": 349767639,
                      "messages": [
                          "작업이 정상적으로 등록되었습니다."
                      ]
                  },
                  {
                      "shop_cd": "A001",
                      "shop_id": "test_shop2",
                      "status": "실패",
                      "error_code": "e6025",
                      "messages": [
                          "사용가능한 쇼핑몰이 아닙니다."
                      ]
                  }
              ]
          },
          error_example: {
            "error_code": "e6xxx",
            "messages": [
              "에러 메세지"
            ]
          }
        },
      ]
    }
  ];
};

export default getV12APIs;
